<template>

  <div>

    <template v-if="context.parent && context.parent.tag==='subForm'">
      <el-input v-if="type==='fill'" v-model="value" @blur="handleChange(value)"
                style="width: 100%;" placeholder="请输入" :input-style="getStyle()"
                :disabled="context.authentication.isDisabled(element,data) || !context.authentication.isWrite(element)"
      ></el-input>
      <div v-else-if="type==='detail'" :style="getStyle()">{{ data[element.id] }}</div>
    </template>
    <el-form-item v-else :required="context.authentication.isRequired(element)">
      <template #label>
      <span :style="{color:'#344262','font-weight':context.form.setting.style.PC.title}">{{ element.label }}
        <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
      </template>
      <el-input v-if="type==='fill'" v-model="value" @blur="handleChange(value)"
                style="width: 100%" placeholder="请输入" :input-style="getStyle()"
                :disabled="context.authentication.isDisabled(element,data)"></el-input>

      <div v-else-if="type==='detail'" class="design-detail" :style="getStyle()">{{ data[element.id] }}</div>
    </el-form-item>

  </div>
</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useFormStore} from "@/stores/form";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";
import {dynamicFunction} from "@/pojo/script";
import {useHttpStore} from "@/stores/http";
import {debounce} from 'lodash';

export default {
  components: {FormElementTooltip},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      value: '',
      data: {},
      type: '',
      debouncedHandler: debounce((newValue, oldValue) => {

        //上一次编辑的是自己，就不要重新计算自己了
        let lastEditElement =  this.formStore.lastEditElement;
        if(lastEditElement === this.element.id){
          return;
        }

        try {
          let num = Number(dynamicFunction(this.element.default.script.value, {...this.data, ...(this.context.rawData || {})}));
          this.data[this.element.id] = this.fixPrecision(num)
          this.fixed();
        } catch (e) {
          console.error(this.element.label, this.element.default.script.value, e)
        }

      }, 1),
    }
  },
  computed: {
    ...mapStores(useFlowStore, useHttpStore, useFormStore),
  },
  created() {
    this.data = this.context.data;
    this.type = this.flowStore.typeOfElement(this.element, this.context);

    if (this.data[this.element.id] === undefined || this.data[this.element.id] === null) {
      this.data[this.element.id] = 0;
    }

    this.value = this.data[this.element.id];
  },
  mounted() {
    this.initWatch();
  },
  unmounted() {
    if (this.element.default?.script?.value)
      this.debouncedHandler();
  },
  methods: {
    fixPrecision(num) {
      if (!Number.isFinite(num)) return num

      const intDigits = Math.floor(Math.abs(num)).toString().length;

      // 如果启用了 scale，以 scale 为准
      if (this.element.attrs.scale.enable) {
        let scale = this.element.attrs.scale.value
        let precision = intDigits + scale
        return Number(num.toPrecision(Math.min(precision, 12)))
      }

      // 默认：整数位数 + 2
      let precision = Math.min(intDigits + 2, 12)
      return Number(num.toPrecision(precision));
    },
    fixed() {

      if(isNaN(this.data[this.element.id]) ){
        this.data[this.element.id] = 0;
      }

      if (this.element.attrs.scale.enable) {
        let scale = this.element.attrs.scale.value;

        this.data[this.element.id] = this.truncateDecimal(this.data[this.element.id], scale)
      }

    },
    getStyle() {

      if (this.element.attrs.style) {
        let script = this.element.attrs.style.value;
        let params = this.data;
        try {
          return dynamicFunction(script, params);
        } catch (e) {
          return {}
        }
      }
    },
    handleChange(val) {

      if (this.isNumericString(val)) {
        this.data[this.element.id] = Number(val);
      } else {
        this.data[this.element.id] = this.element.attrs.scale.enable ? 0 : Number(val);
      }

      this.data[this.element.id] = isNaN(this.data[this.element.id]) ? 0 : this.data[this.element.id];
      this.fixed();

      this.formStore.lastEditElement = this.element.id;
    },
    isNumericString(str) {
      return /^(-?\d+(\.\d+)?)$/.test(str);
    },
    initWatch() {

      if (this.type === 'fill') {

        this.$watch(`data.${this.element.id}`, (newValue, oldValue)=>{
          this.value = newValue;
        }, {
          deep: true,
          immediate: false
        });

        if (this.element.default.select === 'script' && this.element.default.script.value.length > 0) {

          if (!this.data[this.element.id] || this.element.default.isAlwaysScript) {
            this.debouncedHandler()
          }

          let columns = this.formStore.columnsFlatMap(this.context.form);
          if (this.context.rawData) {

            Object.keys(this.context.rawData)
                .filter(filter => filter !== this.element.id)
                .filter(filter => columns.some(some => !some.parent && some.id === filter))
                .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

              this.$watch(`context.rawData.${key}`, this.debouncedHandler, {
                deep: true,
                immediate: false
              });
            });
          }

          Object.keys(this.data)
              .filter(filter => filter !== this.element.id)
              .filter(filter => columns.some(column => column.id === filter))
              .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

            this.$watch(`data.${key}`, this.debouncedHandler, {
              deep: true,
              immediate: false
            });
          });

        }
      }

      if (this.element.default.select === 'http') {
        let http = this.element.default.http;
        if (this.type === 'fill') {
          if (http.immediate) {
            this.http();
          }

          this.$watch(`data.${http.trigger}`, (newValue, oldValue) => {
            this.http()
          }, {
            deep: true,
            immediate: false
          });
        } else if (http.isPreview) {
          this.http();
        }

      }


    },


    http() {
      let http = this.deepClone(this.element.default.http);
      http.params.forEach(item => {
        try {
          item.value = dynamicFunction(item.script.value, this.data);
        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      })

      http.headers.forEach(item => {
        try {
          item.value = dynamicFunction(item.script.value, this.data);
        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      })
      http.bodies.forEach(item => {
        try {
          item.value = dynamicFunction(item.script.value, this.data);
        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      })


      if (http.json) {
        http.json = dynamicFunction(http.json, this.data);
      }


      this.httpStore.send(http).then(res => {


        try {
          this.data[this.element.id] = dynamicFunction(http.script.post.value, {response: res});
        } catch (err) {
          this.message(this.element.label + "请求处理异常：" + err, 'error');
        }
      }).catch(err => this.message(this.element.label + "请求处理异常：" + err, 'error'))
    }
  }
}

</script>

<style scoped lang="scss">


</style>